import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import UnauthenticatedRoute from './UnauthenticatedRoute';
import Login from '../pages/Auth/Login';
import PrivateRoute from './PrivateRoute';
import PrivateOutlet from './PrivateOutlet';
import PrivateOutletSimple from './PrivateOutletSimple';
import ErrorPage from '../pages/Error/Error';
import CategoryList from '../pages/Master/Category/Index';
import NotificationManagement from '../pages/Master/NotificationManagement/Index';
import BlocksManagement from '../pages/Master/BlocksManagement/Index';
import ImagesManagement from '../pages/Master/ImagesManagement/Index';
import BlockVideosManagement from '../pages/Master/BlockVideosManagement/BlockVideosManagement';
import Home from '../pages/Home/Home';
import UserManagement from '../pages/UserManagement/UserManagement';
import { ImageTypeValue } from '../utils/image';

function Router(): React.ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateOutlet />}>
          <Route path="/" element={<PrivateRoute feature="user_logged"><Home /></PrivateRoute>} />
          <Route path="/user-management" element={<PrivateRoute feature="user_logged"><UserManagement /></PrivateRoute>} />
          <Route path="/video-management" element={<PrivateRoute feature="user_logged"><BlockVideosManagement /></PrivateRoute>} />
          <Route path="/category-management" element={<PrivateRoute feature="user_logged"><CategoryList /></PrivateRoute>} />
          <Route path="/notification-management" element={<PrivateRoute feature="user_logged"><NotificationManagement /></PrivateRoute>} />
          <Route path="/system-images-management" element={<ImagesManagement type={ImageTypeValue.SYSTEM_IMAGE} />} />
          <Route path="/blocks-images-management" element={<ImagesManagement type={ImageTypeValue.BLOCKS_IMAGE} />} />
          <Route path="/system-blocks-management" element={<BlocksManagement />} />
        </Route>
        <Route path="/" element={<PrivateOutletSimple />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/login" element={<UnauthenticatedRoute><Login /></UnauthenticatedRoute>} />
        <Route path="/*" element={<div> Not found </div>} />
      </Routes>
    </BrowserRouter>
  );
}
export default Router;
